import api from "../../core/api";
import { FileModel, Page } from "../../shared/models/models";
import { ChangeProduct, FileResult, Product, ProductsQuery } from "../models/AdminProductsModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.catalogApiBaseUrl };
}

class AdminProductsApi {
  getProducts(query: ProductsQuery): Promise<Page<Product>> {
    return api.get<Page<Product>>(`/v1/admin/products`, { ...getRequestConfig(), params: query}).then(x => x.data);
  }

  createProduct(model: ChangeProduct): Promise<void> {
    return api.post('/v1/admin/products', model, getRequestConfig()).then(x => x.data);
  }

  createProductFromFile(model: FileModel): Promise<FileResult> {
    return api.post<FileResult, any>('/v1/admin/products/bulk', model, getRequestConfig()).then(x => x.data);
  }

  changeProduct(id: string, products: ChangeProduct): Promise<any> {
    return api.put(`/v1/admin/products/${id}`, products, getRequestConfig()).then(x => x.data);
  }

  deleteProduct(id: string): Promise<any> {
    return api.delete(`/v1/admin/products/${id}`, getRequestConfig());
  }
}

export default new AdminProductsApi();